import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana104Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1443_5708)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M295.193 690.313L256.87 655.822L301.58 634.105L323.297 678.816L295.193 690.313Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M360.345 660.933L323.299 678.818L301.582 634.107L338.628 616.223L360.345 660.933Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M397.391 643.053L360.345 660.937L338.628 616.226L375.674 598.342L397.391 643.053Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M434.436 625.162L397.39 643.046L375.673 598.336L413.997 580.451L434.436 625.162Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M472.758 607.283L434.435 625.167L413.995 580.457L451.042 562.572L472.758 607.283Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M509.809 589.396L472.763 607.281L451.046 562.57L488.092 544.686L509.809 589.396Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M546.854 571.512L509.808 589.396L488.091 544.685L525.138 528.078L546.854 571.512Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M583.9 553.629L546.854 571.513L525.137 528.08L563.461 508.918L583.9 553.629Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M622.222 535.746L583.898 553.63L563.459 508.919L600.505 491.035L622.222 535.746Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M660.545 516.58L622.221 535.742L600.505 491.031L637.551 473.146L660.545 516.58Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M692.233 500.154L660.544 516.585L637.55 473.152L672.042 456.545C677.577 464.635 689.415 482.094 692.481 487.204C694.368 490.35 695.062 493.334 695.216 495.561C695.355 497.564 694.015 499.23 692.233 500.154Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M646.494 418.218L672.043 456.542L631.165 475.704L609.448 430.993C612.429 429.29 620.434 424.861 628.61 420.773C636.786 416.685 643.939 417.367 646.494 418.218Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M572.398 450.158L609.444 430.996L631.161 475.707L594.114 493.591L572.398 450.158Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M535.352 468.039L572.398 450.154L594.115 493.588L555.792 512.749L535.352 468.039Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M497.03 485.927L535.354 468.043L555.793 512.754L518.747 530.638L497.03 485.927Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M458.709 503.806L497.032 485.922L518.749 530.633L480.425 548.517L458.709 503.806Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M420.386 521.693L458.71 503.809L480.426 548.519L442.103 566.404L420.386 521.693Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M382.06 539.578L420.384 521.693L442.1 566.404L403.777 585.566L382.06 539.578Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M345.014 557.461L382.06 539.576L403.777 585.564L366.731 602.171L345.014 557.461Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M306.688 575.345L345.011 557.461L366.728 602.172L328.404 621.334L306.688 575.345Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M268.37 593.226L306.693 575.342L328.41 621.33L290.087 639.214L268.37 593.226Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M238.986 607.279L268.367 593.227L290.083 639.215L256.869 655.822L235.154 622.608C231.066 615.454 236.005 609.408 238.986 607.279Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1443_5708" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1443_5708" transform="matrix(0.00175224 0 0 0.002323 -3.70254 -2.42728)"/>
    </pattern>
    <image id="image0_1443_5708" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};